import React from 'react';

const SVGDiamond = (props) => {
	return (
		<svg version="1.1" viewBox="0 0 512 335" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path fill="transparent" stroke="#e6e7e8" d="m17.205 102.37 237.8 215.42 239.79-215.42-109.91-85.167h-254.78z" strokeLinecap="round" strokeLinejoin="round" strokeWidth="34.413" />
		</svg>
	);
}

export default SVGDiamond;
